import { apiRequest } from "@/api";

const state = {
  store: {},
  storeIds: undefined,
};

const mutations = {
  SET_STORE: (state, store) => {
    state.store = store;
  },
  SET_STORE_IDS: (state, storeIds) => {
    state.storeIds = storeIds;
  },
};

const actions = {
  FETCH_STORE: ({ commit }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .get("stores/fetchStore")
        .then(({ data }) => {
          commit("SET_STORE", data.response);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),

  FETCH_STORE_IDS: ({ commit }) => {
    return apiRequest()
      .get("stores/ids")
      .then(({ data }) => {
        commit("SET_STORE_IDS", data.response.store_ids);
      });
  },
  // eslint-disable-next-line no-empty-pattern
  UPDATE_STORE: ({}, params) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("stores/update", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  CHANGE_BOX_ENABLE_STAT: ({}, enable) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post(`stores/BoxEnableChangeStat`, enable)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
};

export default { state, mutations, actions };
